import { CheckoutState } from '../state';
import { getTlzEnv } from '../utils/bff';
import { getIsProd } from './app';
import { getEventId } from './event';

export const getBffRequestBaseParams = (state: CheckoutState) => ({
    eventId: getEventId(state),
    env: getTlzEnv(getIsProd(state)),
});
